// External pakcages
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

// Components
import { Option, SelectField, SelectFieldProps } from 'components/Select';

// Hooks
import { useGetAllMedia } from 'api/media';

// Types
import { Media } from '../../../server/src/types/media.types';

export const PlaceMapSelectField: React.FC<
  Omit<SelectFieldProps, 'children' | 'items'>
> = (props) => {
  const { data: media, isLoading } = useGetAllMedia('placeMaps');
  const { control } = useFormContext();
  
  // Watch the current value to ensure it updates when data loads
  const currentValue = useWatch({ control, name: props.name || 'mapId' });

  return (
    <SelectField 
      items={media} 
      {...props} 
      isDisabled={isLoading || !media?.length}
    >
      <Option key="none" id="">-</Option>
      {media?.map((item: Media) => (
        <Option key={item.id} id={item.id}>
          {item.id}
        </Option>
      )) || []}
    </SelectField>
  );
};
